export const SELECTORS = {
  SLIDER: 'js-reviews-slider',
  REVIEWS_STARS: 'js-reviews-slider-stars',
  ITEM: 'js-reviews-slider-item'
};

export const DELAY = 5000;
